var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162.697,
    height: 186,
    viewBox: "0 0 162.697 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6f9c87;}.b{fill:#e1dfcf;}.c{fill:#231f20;}.d{fill:#efab48;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.986 -2140.069)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.077 2140.069)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M114.21,2165.828c6.885-6.257,4.715-15.577,0-25.759C108.557,2151.279,108.277,2160,114.21,2165.828Z",
    transform: "translate(-109.865 -2140.069)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.596 2140.56)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M123.66,2164.29c8.777-3.082,10.408-12.511,10.029-23.727C124.117,2148.687,120.466,2156.607,123.66,2164.29Z",
    transform: "translate(-122.53 -2140.563)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.551 2159.588)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M80.852,2173.99c-1.394-9.2-10.355-12.556-21.444-14.273C65.608,2170.635,72.708,2175.7,80.852,2173.99Z",
    transform: "translate(-59.408 -2159.717)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.076 2178.483)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M66.148,2198.329c-.488-9.29-9.079-13.507-19.946-16.3C51.305,2193.5,57.878,2199.233,66.148,2198.329Z",
    transform: "translate(-46.202 -2182.03)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.754 2193.723)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M52.577,2210.555c-2.338-9-11.6-11.418-22.8-11.977C37.068,2208.8,44.655,2213.1,52.577,2210.555Z",
    transform: "translate(-29.772 -2198.578)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.666 2207.147)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M53.429,2217.432c-6.289-6.856-15.6-4.643-25.759.118C38.907,2223.152,47.623,2223.392,53.429,2217.432Z",
    transform: "translate(-27.67 -2213.092)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.694 2144.158)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M87.306,2165.308c2.065-9.072-5.049-15.472-14.743-21.123C74.343,2156.613,79.1,2163.921,87.306,2165.308Z",
    transform: "translate(-72.563 -2144.185)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.715 2160.771)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M152.583,2178.956c9.288.529,14.418-7.549,18.379-18.048C159,2164.729,152.587,2170.637,152.583,2178.956Z",
    transform: "translate(-152.583 -2160.908)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(146.993 2174.543)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M160.5,2193.4c9.155,1.655,15.23-5.74,20.437-15.68C168.606,2180.056,161.52,2185.14,160.5,2193.4Z",
    transform: "translate(-160.504 -2177.718)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.63 2203.757)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M162.151,2221.185c8.7,3.3,16.023-2.852,22.965-11.668C172.56,2209.554,164.663,2213.253,162.151,2221.185Z",
    transform: "translate(-162.151 -2209.517)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.986 2306.837)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M151.821,2339.944c-21.048-9.09-41.445-16.409-53.129,0-31.25-24.27-55.785-26.36-71.705,0Z",
    transform: "translate(-26.986 -2320.949)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.279 6.723)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M108.435,2339.988c14.974-5.872,29.486-10.6,37.8,0,22.233-15.68,39.688-17.031,51.015,0Z",
    transform: "translate(-108.435 -2327.716)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.371 9.968)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M137.718,2340.01c11.014-4.32,21.688-7.8,27.8,0,16.353-11.533,29.192-12.527,37.524,0Z",
    transform: "translate(-137.718 -2330.983)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.117 2155.284)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M114.237,2321.74a.292.292,0,0,1-.3-.279v-165.8a.3.3,0,0,1,.607,0v165.8A.292.292,0,0,1,114.237,2321.74Z",
    transform: "translate(-113.933 -2155.384)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.05 2169.584)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M114.432,2254.983a.3.3,0,0,1-.085-.594c15.65-4.591,18.73-18.915,22.3-35.5,3.486-16.212,7.438-34.588,23.739-48.852a.3.3,0,0,1,.4.457c-16.151,14.132-20.08,32.4-23.547,48.523-3.607,16.775-6.723,31.263-22.719,35.955A.317.317,0,0,1,114.432,2254.983Z",
    transform: "translate(-114.128 -2169.961)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128.356 2181.379)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M139.228,2209.981a.3.3,0,0,1-.183-.547l31.863-24a.3.3,0,1,1,.365.485l-31.862,24A.3.3,0,0,1,139.228,2209.981Z",
    transform: "translate(-138.925 -2185.373)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.507 2154.455)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M114.019,2217.227a.235.235,0,0,1-.054,0c-11.591-2.083-15.812-16.462-20.28-31.685-3.256-11.088-6.621-22.554-13.007-30.493a.3.3,0,0,1,.474-.381c6.46,8.033,9.844,19.558,13.116,30.7,4.415,15.038,8.584,29.242,19.805,31.259a.3.3,0,0,1-.054.6Z",
    transform: "translate(-80.611 -2154.55)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.246 2164.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M92.825,2182.951a.312.312,0,0,1-.171-.053L67,2165.519a.3.3,0,1,1,.34-.5L92.995,2182.4a.3.3,0,0,1-.17.555Z",
    transform: "translate(-66.866 -2164.963)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.605 2153.628)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M114.236,2186.187a.3.3,0,0,1-.116-.023.3.3,0,0,1-.163-.4L127.2,2153.9a.3.3,0,0,1,.561.232L114.517,2186A.3.3,0,0,1,114.236,2186.187Z",
    transform: "translate(-113.933 -2153.717)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.126 2182.913)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M113.446,2270.006a.3.3,0,0,1-.116-.023c-8.794-3.639-15.17-8.674-20.065-15.845-4.371-6.4-7.055-13.772-9.9-21.573-4.948-13.583-10.557-28.979-26.809-42.909a.3.3,0,1,1,.4-.46c16.372,14.032,22.01,29.507,26.984,43.161,5.71,15.674,10.642,29.21,29.625,37.065a.3.3,0,0,1-.116.584Z",
    transform: "translate(-56.452 -2189.123)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.018 2199.217)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M82.324,2229.971a.3.3,0,0,1-.161-.047l-38.9-24.414a.3.3,0,1,1,.322-.513l38.9,24.414a.3.3,0,0,1-.162.56Z",
    transform: "translate(-43.124 -2204.95)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.018 2210.592)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M62.463,2218.047h-.014l-19.035-.827a.3.3,0,1,1,.026-.606l19.036.827a.3.3,0,0,1-.013.607Z",
    transform: "translate(-43.124 -2216.613)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(121.346 2208.344)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M132.147,2239.554a.3.3,0,0,1-.154-.565l40.552-24a.3.3,0,1,1,.309.523l-40.552,24A.309.309,0,0,1,132.147,2239.554Z",
    transform: "translate(-131.843 -2214.946)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.943 2174.297)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 8.815,
    cy: 8.815,
    r: 8.815
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.283 1.283)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M91.57,2193.834A7.532,7.532,0,1,1,99.1,2186.3,7.541,7.541,0,0,1,91.57,2193.834Zm0-14.458A6.926,6.926,0,1,0,98.5,2186.3,6.933,6.933,0,0,0,91.57,2179.376Z",
    transform: "translate(-84.038 -2178.769)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.755 1.441)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.482)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M91.6,2190.93a2.634,2.634,0,0,1-2.778-2.456.3.3,0,1,1,.607,0,2.2,2.2,0,0,0,4.341,0c0-1.1-.863-1.453-2.284-1.9-1.249-.39-2.664-.833-2.664-2.41a2.8,2.8,0,0,1,5.554,0,.3.3,0,0,1-.606,0,2.2,2.2,0,0,0-4.341,0c0,1.055.845,1.4,2.238,1.831,1.27.4,2.709.846,2.709,2.476A2.634,2.634,0,0,1,91.6,2190.93Z",
    transform: "translate(-88.824 -2181.712)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M92.3,2192.4a.3.3,0,0,1-.3-.3v-11.575a.3.3,0,1,1,.607,0V2192.1A.3.3,0,0,1,92.3,2192.4Z",
    transform: "translate(-91.995 -2180.22)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.501)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M90.638,2192.4a.3.3,0,0,1-.3-.3v-11.575a.3.3,0,1,1,.606,0V2192.1A.3.3,0,0,1,90.638,2192.4Z",
    transform: "translate(-90.335 -2180.22)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(122.3 2191.385)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 8.815,
    cy: 8.815,
    r: 8.815
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.282 1.283)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M140.108,2212.51a7.532,7.532,0,1,1,7.533-7.532A7.541,7.541,0,0,1,140.108,2212.51Zm0-14.458a6.925,6.925,0,1,0,6.926,6.926A6.933,6.933,0,0,0,140.108,2198.052Z",
    transform: "translate(-132.576 -2197.446)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.756 1.441)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.482)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M140.14,2209.607a2.634,2.634,0,0,1-2.777-2.456.3.3,0,1,1,.607,0,2.2,2.2,0,0,0,4.34,0c0-1.1-.862-1.454-2.284-1.9-1.249-.39-2.663-.833-2.663-2.411a2.8,2.8,0,0,1,5.554,0,.3.3,0,0,1-.607,0,2.2,2.2,0,0,0-4.34,0c0,1.056.845,1.4,2.237,1.832,1.271.4,2.71.846,2.71,2.476A2.635,2.635,0,0,1,140.14,2209.607Z",
    transform: "translate(-137.363 -2200.389)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M140.837,2211.079a.3.3,0,0,1-.3-.3V2199.2a.3.3,0,0,1,.606,0v11.576A.3.3,0,0,1,140.837,2211.079Z",
    transform: "translate(-140.534 -2198.897)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M139.177,2211.079a.3.3,0,0,1-.3-.3V2199.2a.3.3,0,0,1,.607,0v11.576A.3.3,0,0,1,139.177,2211.079Z",
    transform: "translate(-138.873 -2198.897)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.099 2212.697)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 8.815,
    cy: 8.815,
    r: 8.815,
    transform: "translate(0 17.403) rotate(-80.783)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.581 2.581)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M81.075,2237.209a7.533,7.533,0,1,1,7.532-7.533A7.541,7.541,0,0,1,81.075,2237.209Zm0-14.458A6.926,6.926,0,1,0,88,2229.676,6.934,6.934,0,0,0,81.075,2222.751Z",
    transform: "translate(-73.543 -2222.144)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.755 1.441)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.482)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M81.107,2234.305a2.634,2.634,0,0,1-2.778-2.456.3.3,0,0,1,.607,0,2.2,2.2,0,0,0,4.34,0c0-1.1-.862-1.452-2.283-1.9-1.249-.39-2.664-.833-2.664-2.41a2.8,2.8,0,0,1,5.554,0,.3.3,0,0,1-.607,0,2.2,2.2,0,0,0-4.34,0c0,1.056.845,1.4,2.238,1.831,1.27.4,2.709.846,2.709,2.475A2.634,2.634,0,0,1,81.107,2234.305Z",
    transform: "translate(-78.329 -2225.087)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M81.8,2235.776a.3.3,0,0,1-.3-.3V2223.9a.3.3,0,1,1,.607,0v11.575A.3.3,0,0,1,81.8,2235.776Z",
    transform: "translate(-81.5 -2223.595)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M80.143,2235.776a.3.3,0,0,1-.3-.3V2223.9a.3.3,0,1,1,.607,0v11.575A.3.3,0,0,1,80.143,2235.776Z",
    transform: "translate(-79.839 -2223.595)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(135.726 2215.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 8.815,
    cy: 8.815,
    r: 8.815
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.283 1.283)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M154.8,2238.459a7.532,7.532,0,1,1,7.532-7.533A7.541,7.541,0,0,1,154.8,2238.459Zm0-14.458a6.926,6.926,0,1,0,6.925,6.926A6.933,6.933,0,0,0,154.8,2224Z",
    transform: "translate(-147.268 -2223.394)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.755 1.441)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.481)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M154.832,2235.555a2.635,2.635,0,0,1-2.778-2.457.3.3,0,0,1,.607,0,2.2,2.2,0,0,0,4.341,0c0-1.1-.863-1.452-2.284-1.9-1.249-.389-2.664-.832-2.664-2.41a2.8,2.8,0,0,1,5.555,0,.3.3,0,1,1-.607,0,2.2,2.2,0,0,0-4.341,0c0,1.056.845,1.4,2.238,1.831,1.27.4,2.71.846,2.71,2.476A2.635,2.635,0,0,1,154.832,2235.555Z",
    transform: "translate(-152.054 -2226.336)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M155.529,2237.027a.3.3,0,0,1-.3-.3v-11.575a.3.3,0,0,1,.607,0v11.575A.3.3,0,0,1,155.529,2237.027Z",
    transform: "translate(-155.225 -2224.844)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.501)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M153.868,2237.027a.3.3,0,0,1-.3-.3v-11.575a.3.3,0,0,1,.607,0v11.575A.3.3,0,0,1,153.868,2237.027Z",
    transform: "translate(-153.565 -2224.844)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(127.469 2306.176)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 8.815,
    cy: 8.815,
    r: 8.815,
    transform: "matrix(1, -0.029, 0.029, 1, 0, 0.519)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.538 1.537)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M146.042,2338.426a7.575,7.575,0,1,1,.486-.016C146.366,2338.421,146.2,2338.426,146.042,2338.426Zm.021-14.458c-.149,0-.3,0-.447.014a6.93,6.93,0,1,0,.447-.014Z",
    transform: "translate(-138.52 -2323.359)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.673 2.244)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.793 1.073)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M144.973,2335.133h-.017a3.047,3.047,0,0,1-2.924-2.576,2.311,2.311,0,0,1,.535-1.862.3.3,0,0,1,.456.4,1.7,1.7,0,0,0-.389,1.38,2.438,2.438,0,0,0,2.326,2.05h.013a1.709,1.709,0,0,0,1.307-.56c.73-.829.313-1.66-.46-2.933-.679-1.119-1.448-2.385-.405-3.57a2.8,2.8,0,0,1,4.168,3.672.3.3,0,1,1-.455-.4,2.2,2.2,0,0,0-3.257-2.869c-.7.791-.289,1.606.468,2.853.691,1.137,1.474,2.426.4,3.649A2.309,2.309,0,0,1,144.973,2335.133Z",
    transform: "translate(-142.01 -2326.699)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.238 1.091)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M142.76,2336.008a.3.3,0,0,1-.227-.5l7.653-8.686a.3.3,0,1,1,.455.4l-7.653,8.685A.3.3,0,0,1,142.76,2336.008Z",
    transform: "translate(-142.457 -2326.716)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M141.514,2334.91a.3.3,0,0,1-.227-.5l7.653-8.685a.3.3,0,1,1,.455.4l-7.652,8.686A.306.306,0,0,1,141.514,2334.91Z",
    transform: "translate(-141.211 -2325.618)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.469 2304.423)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 8.815,
    cy: 8.815,
    r: 8.815,
    transform: "translate(0 17.01) rotate(-74.754)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.294 3.29)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M62.56,2338.426a7.533,7.533,0,1,1,4.99-13.185h0a7.532,7.532,0,0,1-4.5,13.169C62.883,2338.421,62.721,2338.426,62.56,2338.426Zm.02-14.458c-.148,0-.3,0-.447.014a6.927,6.927,0,1,0,5.016,1.716h0A6.873,6.873,0,0,0,62.58,2323.967Z",
    transform: "translate(-55.041 -2323.359)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.24 2.896)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.074 0.573)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M63.89,2334.979a2.274,2.274,0,0,1-1.518-.556.3.3,0,0,1,.4-.455,2.2,2.2,0,0,0,2.87-3.258c-.829-.729-1.66-.313-2.933.46-1.119.679-2.385,1.448-3.569.405a2.8,2.8,0,0,1,3.672-4.167.3.3,0,0,1-.4.455,2.2,2.2,0,0,0-2.87,3.258c.793.7,1.606.288,2.854-.469,1.137-.691,2.426-1.473,3.649-.4a2.635,2.635,0,0,1,.006,3.708A2.915,2.915,0,0,1,63.89,2334.979Z",
    transform: "translate(-58.377 -2326.852)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.09)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M67.382,2334.534a.3.3,0,0,1-.2-.075l-8.685-7.653a.3.3,0,1,1,.4-.455L67.582,2334a.3.3,0,0,1-.2.531Z",
    transform: "translate(-58.394 -2326.275)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.238)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M66.285,2335.78a.3.3,0,0,1-.2-.076l-8.686-7.652a.3.3,0,0,1,.4-.455l8.685,7.653a.3.3,0,0,1-.2.531Z",
    transform: "translate(-57.296 -2327.521)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.2b2f4afc4d5f50ceb1d0d7badf6ce99e.svg";
export { ForwardRef as ReactComponent };